import { createStyles } from 'antd-style';

export const useDataRenderersStyles = createStyles(() => ({
  staleData: {
    position: 'relative',
    filter: 'blur(2px)',
  },
}));
